import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'

export interface TitleProps {
  children: string
}

const StyledTitle = styled.div`
  ${({
    theme: {
      colors: { staticWhite },
      typography: {
        headings: {
          xxsmall: { bundledCSS: xxsmallHeadingsCSS },
          xsmall: { bundledCSS: xsmallHeadingCSS },
        },
      },
      utils: { ellipsis },
    },
  }) => css`
    position: relative;
    ${xxsmallHeadingsCSS};
    ${desktopCSS(css`
      ${xsmallHeadingCSS};
    `)};
    color: ${staticWhite};

    ${ellipsis('100%', 4)};
  `}
`

const Title: FunctionComponent<TitleProps> = ({ children }) => (
  <StyledTitle>{children}</StyledTitle>
)

export default Title
